// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".content-divider-section[data-v-0de6048c]{padding:40px 0}@media(min-width:768px){.content-divider-section[data-v-0de6048c]{padding:50px 0}}hr[data-v-0de6048c]{border-top:3px solid #f6f6f6;margin:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
